import { AppPagePaths } from "App/routes/paths";

export const REPORTING_PAGE_DESCRIPTIONS = {
    [AppPagePaths.reporting]: "Analytics and reporting dashboard with customizable metrics.",
} as const;
